@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

.LabeledRadio {
  @extend %form-control-font;

  display: inline-flex;
  padding: 7px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: $theme-color-input-readonly;
  border: 1px solid transparent;
  cursor: pointer;

  &.isChecked {
    border: 1px solid $color-primary-purple;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  &.Disabled {
    cursor: default;
    background: $theme-color-input-readonly;
    opacity: 0.5;
  }

  &.isCheckedAndIsDisabled {
    border: 1px solid $color-primary-purple-50;
  }

  &.isDarkerBackgroundInDarkMode {
    background: $theme-color-slider-input-background;
  }
}
